<template lang="html">
  <div id="dashboard-analytics">
    <div class="vx-row">

      <!-- CARD 1: CONGRATS -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <router-link :to="`/associate/users/bride`" class="text-inherit hover:text-primary"><statistics-card-line icon="UsersIcon" :statistic="totalBrides.analyticsData.data" statisticTitle="Brides" :chartData="totalBrides.series" type="area"></statistics-card-line></router-link>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <router-link :to="`/associate/users/vendor`" class="text-inherit hover:text-primary"><statistics-card-line icon="UsersIcon" :statistic="totalVendor.analyticsData.data" statisticTitle="Vendors" :chartData="totalVendor.series" type="area"></statistics-card-line></router-link>
      </div>

      <!--<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="DollarSignIcon" :statistic="totalPayments.analyticsData.data" statisticTitle="Payments" :chartData="totalPayments.series" color="success" type="area"></statistics-card-line>
      </div>-->

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <router-link :to="`/associate/service-request`" class="text-inherit hover:text-primary"><statistics-card-line icon="FileIcon" :statistic="totalSR.analyticsData.data" statisticTitle="Total Service Requests" :chartData="totalSR.series" color="warning" type="area"></statistics-card-line></router-link>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <router-link :to="`/associate/service-request`" class="text-inherit hover:text-primary"><statistics-card-line icon="BookIcon" :statistic="totalSRAccepted.analyticsData.data" statisticTitle="SR Accepted" color="success" :chartData="totalSRAccepted.series" type="area"></statistics-card-line></router-link>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <router-link :to="`/associate/events`" class="text-inherit hover:text-primary"><statistics-card-line icon="UmbrellaIcon" :statistic="totalEvents.analyticsData.data" statisticTitle="Events" :chartData="totalEvents.series" color="danger" type="area"></statistics-card-line></router-link>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <router-link :to="`/associate/transactions`" class="text-inherit hover:text-primary"><statistics-card-line icon="FileIcon" :statistic="totalQuotes.analyticsData.data" statisticTitle="Quotes" :chartData="totalQuotes.series" color="warning" type="area"></statistics-card-line></router-link>
      </div>
    </div>

    <div class="vx-row">

      <!-- LINE CHART -->
      <!--<div class="vx-col w-full mb-base">
        <vx-card title="Bride Payments">
          <div slot="no-body" class="p-6 pb-0">
            <div class="flex" v-if="revenueComparisonLine.analyticsData">
              <div class="mr-6">
                <p class="mb-1 font-semibold">This Month</p>
                <p class="text-3xl text-success"><sup class="text-base mr-1">$</sup>{{ revenueComparisonLine.analyticsData.thisMonth }}</p>
              </div>
              <div>
                <p class="mb-1 font-semibold">Last Month</p>
                <p class="text-3xl"><sup class="text-base mr-1">$</sup>{{ revenueComparisonLine.analyticsData.lastMonth }}</p>
              </div>
            </div>
            <vue-apex-charts
              type="line"
              height="266"
              :options="analyticsData.revenueComparisonLine.chartOptions"
              :series="revenueComparisonLine.series" />
          </div>
        </vx-card>
      </div>-->
    </div>

    <div class="vx-row">

      <!-- CARD 1: CONGRATS -->

      <!--<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-base">
        <statistics-card-line icon="DollarSignIcon" :statistic="totalQuotePayments.analyticsData.data" statisticTitle="Quote Payments" :chartData="totalQuotePayments.series" color="success" type="area"></statistics-card-line>
      </div>-->
    </div>


    <!--<div class="vx-row">

  &lt;!&ndash; CARD 4: SESSION &ndash;&gt;
  <div class="vx-col w-full md:w-1/2 mb-base">
    <vx-card>
      <div class="vx-row flex-col-reverse md:flex-col-reverse sm:flex-row lg:flex-row">

        &lt;!&ndash; LEFT COL &ndash;&gt;
        <div class="vx-col w-full md:w-full sm:w-1/2 lg:w-1/2 xl:w-1/2 flex flex-col justify-between" v-if="salesBarSession.analyticsData">
          <div>
            <h2 class="mb-1 font-bold">{{ salesBarSession.analyticsData.session | k_formatter }}</h2>
            <span class="font-medium">Avg Sessions</span>

            &lt;!&ndash; Previous Data Comparison &ndash;&gt;
            <p class="mt-2 text-xl font-medium">
              <span :class="salesBarSession.analyticsData.comparison.result >= 0 ? 'text-success' : 'text-danger'">
                <span v-if="salesBarSession.analyticsData.comparison.result > 0">+</span>
                <span>{{ salesBarSession.analyticsData.comparison.result }}</span>
              </span>
              <span> vs </span>
              <span>{{ salesBarSession.analyticsData.comparison.str }}</span>
            </p>
          </div>
          <vs-button icon-pack="feather" icon="icon-chevrons-right" icon-after class="shadow-md w-full lg:mt-0 mt-4">View Details</vs-button>
        </div>

        &lt;!&ndash; RIGHT COL &ndash;&gt;
        <div class="vx-col w-full md:w-full sm:w-1/2 lg:w-1/2 xl:w-1/2 flex flex-col lg:mb-0 md:mb-base sm:mb-0 mb-base">
          <change-time-duration-dropdown class="self-end" />
          <vue-apex-charts type="bar" height="200" :options="analyticsData.salesBar.chartOptions" :series="salesBarSession.series" v-if="salesBarSession.series" />
        </div>

      </div>
      <vs-divider class="my-6"></vs-divider>
      <div class="vx-row">
        <div class="vx-col w-1/2 mb-3">
          <p>Goal: $100000</p>
          <vs-progress class="block mt-1" :percent="50" color="primary"></vs-progress>
        </div>
        <div class="vx-col w-1/2 mb-3">
          <p>Users: 100K</p>
          <vs-progress class="block mt-1" :percent="60" color="warning"></vs-progress>
        </div>
        <div class="vx-col w-1/2 mb-3">
          <p>Retention: 90%</p>
          <vs-progress class="block mt-1" :percent="70" color="danger"></vs-progress>
        </div>
        <div class="vx-col w-1/2 mb-3">
          <p>Duration: 1yr</p>
          <vs-progress class="block mt-1" :percent="90" color="success"></vs-progress>
        </div>
      </div>
    </vx-card>
  </div>


  &lt;!&ndash; CARD 5: SUPPORT TRACKER &ndash;&gt;
  <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
      <vx-card title="Support Tracker">
          &lt;!&ndash; CARD ACTION &ndash;&gt;
          <template slot="actions">
              <change-time-duration-dropdown />
          </template>

          <div slot="no-body" v-if="supportTracker.analyticsData">
              <div class="vx-row text-center">

                  &lt;!&ndash; Open Tickets Heading &ndash;&gt;
                  <div class="vx-col w-full lg:w-1/5 md:w-full sm:w-1/5 flex flex-col justify-between mb-4 lg:order-first md:order-last sm:order-first order-last">
                      <div class="lg:ml-6 lg:mt-6 md:mt-0 md:ml-0 sm:ml-6 sm:mt-6">
                          <h1 class="font-bold text-5xl">{{ supportTracker.analyticsData.openTickets }}</h1>
                          <small>Tickets</small>
                      </div>
                  </div>

                  &lt;!&ndash; Chart &ndash;&gt;
                  <div class="vx-col w-full lg:w-4/5 md:w-full sm:w-4/5 justify-center mx-auto lg:mt-0 md:mt-6 sm:mt-0 mt-6">
                      <vue-apex-charts type="radialBar" height="385" :options="analyticsData.supportTrackerRadialBar.chartOptions" :series="supportTracker.series" />
                  </div>
              </div>

              &lt;!&ndash; Support Tracker Meta Data &ndash;&gt;
              <div class="flex flex-row justify-between px-8 pb-4 mt-4">
                  <p class="text-center" v-for="(val, key) in supportTracker.analyticsData.meta" :key="key">
                    <span class="block">{{ key }}</span>
                    <span class="text-2xl font-semibold">{{ val }}</span>
                  </p>
              </div>
          </div>
      </vx-card>
  </div>

</div>-->

  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import analyticsData from './ui-elements/card/analyticsData.js'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
import axios from '@/axios.js'

export default {
  components: {
    analyticsData,
    VueApexCharts,
    ChangeTimeDurationDropdown,
    StatisticsCardLine,
    VuePerfectScrollbar
  },
  data () {
    return {
      totalBrides: {
        series: [],
        analyticsData: {
          data: 0
        }
      },
      totalVendor: {
        series: [],
        analyticsData: {
          data: 0
        }
      },
      totalSR: {
        series: [],
        analyticsData: {
          data: 0
        }
      },
      totalSRAccepted: {
        series: [],
        analyticsData: {
          data: 0
        }
      },
      totalPayments: {
        series: [],
        analyticsData: {
          data: 0
        }
      },
      totalEvents: {
        series: [],
        analyticsData: {
          data: 0
        }
      },
      totalQuotes: {
        series: [],
        analyticsData: {
          data: 0
        }
      },
      totalQuotePayments: {
        series: [],
        analyticsData: {
          data: 0
        }
      },
      revenueComparisonLine: {
        analyticsData : {
          lastMonth: 0,
          thisMonth: 0
        },
        series: [],
        chartOptions: {
          chart: {
            toolbar: { show: false },
            dropShadow: {
              enabled: true,
              top: 5,
              left: 0,
              blur: 4,
              opacity: 0.10
            }
          },
          stroke: {
            curve: 'smooth',
            dashArray: [0, 8],
            width: [4, 2]
          },
          grid: {
            borderColor: '#e7e7e7'
          },
          legend: {
            show: false
          },
          colors: ['#F97794', '#b8c2cc'],
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'dark',
              inverseColors: false,
              gradientToColors: ['#7367F0', '#b8c2cc'],
              shadeIntensity: 1,
              type: 'horizontal',
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100]
            }
          },
          markers: {
            size: 0,
            hover: {
              size: 5
            }
          },
          xaxis: {
            labels: {
              style: {
                cssClass: 'text-grey fill-current'
              }
            },
            axisTicks: {
              show: false
            },
            categories: ['01', '05', '09', '13', '17'],
            axisBorder: {
              show: false
            }
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: 'text-grey fill-current'
              },
              formatter (val) {
                return val > 999 ? `${(val / 1000).toFixed(1)}k` : val
              }
            }
          },
          tooltip: {
            x: { show: false }
          }
        }
      },

      salesBarSession: {
        series: [
          {
            name: 'Sessions',
            data: [75, 125, 225, 175, 125, 75, 25]
          }
        ],
        analyticsData: {
          session: 2700,
          comparison : {
            str: 'Last 7 Days',
            result: +5.2
          }
        }
      },
      supportTracker: {
        analyticsData: {
          openTickets: 163,
          meta: {
            'New Tickets': 29,
            'Open Tickets': 63,
            'Response Time': '1d'
          }
        },
        series: [83]
      },
      analyticsData
    }
  },
  methods: {
    totalBride () {
      axios
        .post('/api/support/dashboard/totalBrides')
        .then(response => {
          this.$set(this.totalBrides.series, 0, response.data.data.recentCount)
          this.totalBrides.analyticsData.data = response.data.data.count
        })
        .catch(error => {
          console.log(error)
        })
    },
    totalServiceRequests () {
      axios
        .post('/api/support/dashboard/totalServiceRequests')
        .then(response => {
          this.$set(this.totalSR.series, 0, response.data.data.recentCount)
          this.totalSR.analyticsData.data = response.data.data.count
        })
        .catch(error => {
          console.log(error)
        })
    },
    totalPayment () {
      axios
        .post('/api/support/dashboard/totalPayment')
        .then(response => {
          this.$set(this.totalPayments.series, 0, response.data.data.recentCount)
          this.totalPayments.analyticsData.data = response.data.data.count
        })
        .catch(error => {
          console.log(error)
        })
    },
    totalEvent () {
      axios
        .post('/api/support/dashboard/totalEvents')
        .then(response => {
          this.$set(this.totalEvents.series, 0, response.data.data.recentCount)
          this.totalEvents.analyticsData.data = response.data.data.count
        })
        .catch(error => {
          console.log(error)
        })
    },
    brideMonthPayment () {
      axios
        .post('/api/support/dashboard/brideMonthPayment')
        .then(response => {
          this.$set(this.revenueComparisonLine.series, 0, response.data.data.thisMonth)
          this.$set(this.revenueComparisonLine.series, 1, response.data.data.lastMonth)
          this.revenueComparisonLine.analyticsData.lastMonth = response.data.data.lastMonthTotal
          this.revenueComparisonLine.analyticsData.thisMonth = response.data.data.thisMonthTotal
        })
        .catch(error => {
          console.log(error)
        })
    },
    totalVendors () {
      axios
        .post('/api/support/dashboard/totalVendors')
        .then(response => {
          this.$set(this.totalVendor.series, 0, response.data.data.recentCount)
          this.totalVendor.analyticsData.data = response.data.data.count
        })
        .catch(error => {
          console.log(error)
        })
    },
    totalQuotePayment () {
      axios
        .post('/api/support/dashboard/totalQuotePayments')
        .then(response => {
          this.$set(this.totalQuotePayment.series, 0, response.data.data.recentCount)
          this.totalQuotePayment.analyticsData.data = response.data.data.count
        })
        .catch(error => {
          console.log(error)
        })
    },
    totalQuote () {
      axios
        .post('/api/support/dashboard/totalQuotes')
        .then(response => {
          this.$set(this.totalQuotes.series, 0, response.data.data.recentCount)
          this.totalQuotes.analyticsData.data = response.data.data.count
        })
        .catch(error => {
          console.log(error)
        })
    },
    totalSRAccept () {
      axios
        .post('/api/admin/dashboard/totalSRAccepted')
        .then(response => {
          this.$set(this.totalSRAccepted.series, 0, response.data.data.recentCount)
          this.totalSRAccepted.analyticsData.data = response.data.data.count
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  created () {
    this.$emit('changeRouteTitle', 'Dashboard')
    this.totalBride()
    this.totalServiceRequests()
    this.totalPayment()
    this.totalEvent()
    this.brideMonthPayment()
    this.totalVendors()
    this.totalQuote()
    this.totalSRAccept()
  }
}
</script>
<style lang="scss">
  /*! rtl:begin:ignore */
  #dashboard-analytics {
    .greet-user{
      position: relative;

      .decore-left{
        position: absolute;
        left:0;
        top: 0;
      }
      .decore-right{
        position: absolute;
        right:0;
        top: 0;
      }
    }

    @media(max-width: 576px) {
      .decore-left, .decore-right{
        width: 140px;
      }
    }
  }
  /*! rtl:end:ignore */
</style>
